import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  Alert,
  IconButton,
  Stack,
  Chip,
  Divider,
} from "@mui/material";
import {
  // PermContactCalendar as PeopleIcon,
  // LocalOffer as LabelIcon,
  // CellTower as CampaignIcon,
  // SettingsSuggest as AutomationIcon,
  // AccountTree as FlowIcon,
  // Inbox as Chat,
  Person as PersonIcon,
  Settings as SettingsIcon,
  CheckCircle as CheckCircleIcon,
  InfoOutlined as InfoOutlinedIcon,
  PhoneIphone as PhoneIphoneIcon,
  AddIcCall as AddIcCallIcon,
  // GroupAddOutlined,
} from "@mui/icons-material";
import { useTheme, useMediaQuery } from "@mui/material";
import MyAccountService from "../services/MyAccountService";
// import { getShortStoreName } from "../utils/extentions";
import FormField from "./FormField";
import { Heading, MenuIcon, Text } from "evergreen-ui";
import { IntegrationDialog } from "./Dialog";
import ServicesService from "../services/ServicesService";
import WhatsApp from "../models/WhatsappModel";
import { errorMessage } from "../shared/utils/validators";
import axios from "axios";
import API_CONFIG from "../config/api.config";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import Logo from "../assets/logo.png";
import WhatsappEmbeddedSyncContent from "./WhatsappEmbeddedSyncContent";

const TopNavigation = ({
  onMenuClick,
  showToolbar = true,
  profileDialogOpen = false,
  onCloseProfileDialog,
}) => {
  const [appId, setAppId] = useState(null);
  const [configId, setConfigId] = useState(null);
  const [pinValue, setPinValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const [isFbReady, setIsFbReady] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [catalogId, setCatalogId] = useState("");
  const [accessToken, setAccessToken] = useState(null);
  const pendingSignupRef = useRef(null);
  const pendingAuthCodeRef = useRef(null);
  const [selectedOnboardingMode, setSelectedOnboardingMode] = useState("business_app");
  const [whatsapp, setWhatsapp] = useState({
    phoneNumberId: "",
    wabaId: "",
    accessToken: "",
    isEmbeddedSignup: 0,
    businessNumber: "",
    isHistory: "not-started",
    isContact: "not-started",
    chunkData: {},
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const [showCopyDialog, setShowCopyDialog] = useState(false);
  const [copiedPhone, setCopiedPhone] = useState(false);
  const [copiedWaba, setCopiedWaba] = useState(false);
  const [copyDialogData, setCopyDialogData] = useState({
    phone_number_id: "",
    waba_id: "",
  });
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // function toggleDrawer() {
  //   setMobileOpen((prev) => !prev);
  // }

  // const [whatsappId, setWhatsappId] = useState(null);
  // const tabs = [
  //   {
  //     id: "teamchat",
  //     label: "Team Inbox",
  //     activeIcon: TeamInbo,
  //     inactiveIcon: TeamInbox1,
  //   },
  //   {
  //     id: "contacts",
  //     label: "Contacts",
  //     activeIcon: Contact,
  //     inactiveIcon: Contact1,
  //   },
  //   // {
  //   //   id: "group",
  //   //   label: "Groups",
  //   //   icon: <GroupAddOutlined fontSize="small" />,
  //   // },
  //   {
  //     id: "tags",
  //     label: "Tags",
  //     activeIcon: Tag,
  //     inactiveIcon: Tag1,
  //   },
  //   {
  //     id: "broadcast",
  //     label: "Broadcast",
  //     activeIcon: Automation,
  //     inactiveIcon: Broadcast1,
  //   },
  //   {
  //     id: "automation",
  //     label: "Automation",
  //     activeIcon: Automation,
  //     inactiveIcon: Automation1,
  //   },
  //   // {
  //   //   id: "flow",
  //   //   label: "Flow",
  //   //   icon: <FlowIcon fontSize="small" />,
  //   // },
  //   {
  //     id: "plan",
  //     label: "Plans",
  //     icon: <FeedSubscribedIcon fontSize="small" />,
  //   },
  //   {
  //     id: "settings",
  //     label: "Settings",
  //     icon: <SettingsIcon fontSize="small" />,
  //   },
  // ];
  const [accName, setAccName] = useState("WG");
  function renderForm() {
    const paths = [
      {
        id: "business_app",
        title: "Use WhatsApp Business App number",
        subtitle: "Use your current business number",
        Icon: PhoneIphoneIcon,
        bestFor: "You already use WhatsApp Business App on your phone and want to keep using it.",
        requirements: [
          "Number must be on WhatsApp Business App 2.24.4+",
          "Business verification may require GST certificate or active website",
          "Admin access to the Facebook business account",
        ],
        notes: [
          "No display name setup in this path. Existing Business App profile remains the customer-facing identity.",
          "WhatsApp native payment configuration for chatbot checkout is not supported for this mode.",
          "Chat history/contact sync is available, but phone-app replies may not behave like pure CRM inbox replies.",
          "Good for fast migration with low disruption.",
        ],
        cta: "Proceed with Business App",
      },
      {
        id: "new_number",
        title: "Use a new WhatsApp number",
        subtitle: "Start with a fresh number",
        Icon: AddIcCallIcon,
        bestFor: "You want to run WhatsApp fully from this inbox (recommended for new setups).",
        requirements: [
          "Fresh phone number not registered on WhatsApp Personal or Business App",
          "Must be able to receive OTP by SMS or voice call",
          "Business verification may require GST certificate or active website",
        ],
        notes: [
          "Supports display name setup and review.",
          "Best support for API-first chatbot, template, broadcast, inbox, and payment workflows.",
          "Cannot use the same number in WhatsApp Personal or Business App after setup.",
          "Recommended for new implementations and teams managing WhatsApp from CRM.",
        ],
        cta: "Proceed with New Number",
      },
    ];
    const selectedPath = paths.find((item) => item.id === selectedOnboardingMode) || paths[0];
    const brand = theme.palette.primary.main;

    return (
      <Box sx={{ width: { xs: "92vw", md: 920 }, maxWidth: "100%" }}>
        <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ sm: "center" }} spacing={1.5} sx={{ mb: 2.5 }}>
          <Chip
            label="Step 1 of 2"
            size="small"
            sx={{
              alignSelf: "flex-start",
              bgcolor: `${brand}14`,
              color: brand,
              fontWeight: 700,
            }}
          />
          <Box sx={{ flex: 1, height: 8, maxWidth: 180, borderRadius: 999, bgcolor: "#e8ecf5", overflow: "hidden" }}>
            <Box sx={{ width: "50%", height: "100%", bgcolor: brand, borderRadius: 999 }} />
          </Box>
          <Chip
            label="WhatsApp Setup"
            size="small"
            sx={{
              alignSelf: "flex-start",
              bgcolor: `${brand}14`,
              color: brand,
              fontWeight: 700,
            }}
          />
        </Stack>

        <Typography sx={{ fontSize: 26, fontWeight: 800, color: "#111827", mb: 0.75 }}>
          Choose how to connect your WhatsApp number
        </Typography>
        <Typography sx={{ color: "#4b5563", fontSize: 15, mb: 2.5, maxWidth: 760, lineHeight: 1.55 }}>
          Select the option that fits your phone number.
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
            gap: 2,
          }}
        >
          {paths.map((path) => {
            const selected = selectedOnboardingMode === path.id;
            const Icon = path.Icon;
            return (
              <Box
                key={path.id}
                onClick={() => setSelectedOnboardingMode(path.id)}
                sx={{
                  cursor: "pointer",
                  borderRadius: 2,
                  border: `2px solid ${selected ? brand : "rgba(15,23,42,0.12)"}`,
                  bgcolor: selected ? `${brand}08` : "#fff",
                  boxShadow: "none",
                  p: 2,
                  minHeight: 140,
                  display: "flex",
                  flexDirection: "column",
                  transition: "border-color 0.15s ease, background-color 0.15s ease",
                  position: "relative",
                  "&:hover": {
                    borderColor: selected ? brand : "rgba(15,23,42,0.22)",
                    bgcolor: selected ? `${brand}0A` : "#fafafa",
                  },
                }}
              >
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2.5,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: `${brand}14`,
                      color: brand,
                    }}
                  >
                    <Icon />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 850, color: "#111827", lineHeight: 1.2 }}>
                      {path.title}
                    </Typography>
                    <Typography sx={{ color: brand, fontSize: 13, fontWeight: 700, mt: 0.3 }}>
                      {path.subtitle}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: "50%",
                      border: `2px solid ${selected ? brand : "rgba(15,23,42,0.18)"}`,
                      display: "grid",
                      placeItems: "center",
                      color: "#fff",
                      bgcolor: selected ? brand : "#fff",
                      flex: "0 0 auto",
                    }}
                  >
                    {selected && <CheckCircleIcon sx={{ fontSize: 20 }} />}
                  </Box>
                </Stack>

                <Typography sx={{ color: "#4b5563", fontSize: 13.5, mt: 2 }}>
                  {path.bestFor}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box
          sx={{
            mt: 2,
            p: 2,
            borderRadius: 3,
            bgcolor: "#f8fafc",
            border: "1px solid rgba(15,23,42,0.08)",
          }}
        >
          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 850, color: "#111827", mb: 0.75 }}>
                Before connecting
              </Typography>
              <Stack spacing={0.75}>
                {selectedPath.requirements.map((item) => (
                  <Stack key={item} direction="row" spacing={0.75} alignItems="flex-start">
                    <CheckCircleIcon sx={{ fontSize: 17, color: brand, mt: "1px" }} />
                    <Typography sx={{ fontSize: 13.2, color: "#334155" }}>{item}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
            <Divider flexItem orientation="vertical" sx={{ display: { xs: "none", md: "block" } }} />
            <Box sx={{ flex: 1.15 }}>
              <Typography sx={{ fontWeight: 850, color: "#111827", mb: 0.75 }}>
                Important notes
              </Typography>
              <Stack spacing={0.75}>
                {selectedPath.notes.map((item) => (
                  <Stack key={item} direction="row" spacing={0.75} alignItems="flex-start">
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: "#64748b", mt: "2px" }} />
                    <Typography sx={{ fontSize: 13.2, color: "#475569" }}>{item}</Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
          </Stack>
        </Box>

        <Box
          sx={{
            position: "sticky",
            bottom: -24,
            mt: 2,
            mx: -1,
            px: 1,
            pt: 1.5,
            pb: 0.5,
            bgcolor: "rgba(255,255,255,0.96)",
            backdropFilter: "blur(8px)",
            borderTop: "1px solid rgba(15,23,42,0.08)",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", sm: "center" }}
            spacing={1.5}
          >
            <Box>
              <Typography sx={{ fontSize: 12, color: "#64748b", fontWeight: 700 }}>
                Selected option
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#111827", fontWeight: 850 }}>
                {selectedPath.title}
              </Typography>
            </Box>
            <Stack direction="row" justifyContent="flex-end" spacing={1.25}>
              <Button
                variant="text"
                onClick={() => setIsOpen(false)}
                sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2, color: "#64748b" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={!isFbReady}
                onClick={() => {
                  launchWhatsAppSignup();
                }}
                sx={{ textTransform: "none", fontWeight: 800, borderRadius: 2, px: 2.75 }}
              >
                {selectedPath.cta}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Box>
    );
  }
  function renderSyncDialog() {
    return (
      <Dialog
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 18 }}>
          Sync WhatsApp Data
        </DialogTitle>

        <DialogContent dividers>
          <WhatsappEmbeddedSyncContent
            isContact={whatsapp.isContact}
            isHistory={whatsapp.isHistory}
            chunkData={whatsapp.chunkData}
            onSync={handleSyncHistory}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setSyncDialogOpen(false)}
            sx={{ textTransform: "none" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function renderCopyDialog() {
    return (
      <Dialog open={showCopyDialog} onClose={() => {}} maxWidth="xs" fullWidth>
        <DialogTitle>Copy Your WhatsApp Details</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            <b>Important:</b> You will <b>not</b> be able to view these values
            later. Please copy them now for your reference.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <TextField
              label="Phone Number ID"
              value={copyDialogData.phone_number_id}
              InputProps={{ readOnly: true }}
              fullWidth
              sx={{ mr: 1 }}
            />
            <Button
              variant={copiedPhone ? "contained" : "outlined"}
              color={copiedPhone ? "success" : "primary"}
              onClick={() => {
                navigator.clipboard.writeText(copyDialogData.phone_number_id);
                setCopiedPhone(true);
              }}
            >
              {copiedPhone ? "Copied" : "Copy"}
            </Button>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <TextField
              label="WABA ID"
              value={copyDialogData.waba_id}
              InputProps={{ readOnly: true }}
              fullWidth
              sx={{ mr: 1 }}
            />
            <Button
              variant={copiedWaba ? "contained" : "outlined"}
              color={copiedWaba ? "success" : "primary"}
              onClick={() => {
                navigator.clipboard.writeText(copyDialogData.waba_id);
                setCopiedWaba(true);
              }}
            >
              {copiedWaba ? "Copied" : "Copy"}
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disabled={!(copiedPhone && copiedWaba)}
            onClick={() => setShowCopyDialog(false)}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  async function createCatalog() {
    try {
      await ServicesService.creatCatalog(catalogId);
      setSnackbar({
        open: true,
        message: "Catalog Connected successfully!",
        severity: "success",
      });
      setIsCatalogOpen(false);
    } catch (error) {
      console.log("error", error);
      setSnackbar({
        open: true,
        message: "Catalog Not Connected",
        severity: "error",
      });
      setIsCatalogOpen(false);
    }
  }
  function renderCatalogForm() {
    return (
      <div style={{ paddingTop: 10, paddingBottom: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 10,
          }}
        >
          <Heading size={500}>Connect Your Catalog</Heading>
        </div>
        <Text style={{ paddingTop: 15 }}>
          Please make sure your catalog connected to your whatsapp business
          number
        </Text>
        <FormField
          type="text"
          label="Catalog id"
          isRequired
          name="catalogId"
          value={catalogId}
          onChange={(e) => {
            setCatalogId(e.target.value);
          }}
          error={
            catalogId && catalogId?.length < 5 ? "Enter valid catalog id" : null
          }
        />
        <div
          className="flex"
          style={{ justifyContent: "end", marginTop: "30px", columnGap: 20 }}
        >
          <Button
            onClick={() => {
              setIsCatalogOpen(false);
              setCatalogId(null);
            }}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            label="Connect"
            disabled={catalogId?.length < 5 || !catalogId}
            onClick={() => {
              createCatalog();
            }}
          >
            Connect
          </Button>
        </div>
      </div>
    );
  }
  function renderSnackbar() {
    return (
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    );
  }
  function renderLoginDialog() {
    return (
      <IntegrationDialog
        isOpen={isOpen}
        title="Connect WhatsApp"
        content={renderForm}
        onCancel={() => {
          setIsOpen(false);
        }}
      />
    );
  }

  function renderCatalogDialog() {
    return (
      <IntegrationDialog
        isOpen={isCatalogOpen}
        title="Connect Catalog"
        content={renderCatalogForm}
        onCancel={() => {
          setIsCatalogOpen(false);
        }}
      />
    );
  }
  function fetchData() {
    ServicesService.getWhatsapp("whatsapp")
      .then((response) => {
        setWhatsapp({
          phoneNumberId: response?.getPhoneNumberId(),
          wabaId: response?.getWabaId(),
          accessToken: response?.getAccessToken(),
          storeId: response?.getStoreId(),
          isEmbeddedSignup: response?.getIsEmbeddedSignup(),
          businessNumber: response?.getPhoneNumber(),
          isHistory: response?.getIsHistorySync(),
          isContact: response?.getIsContactSync(),
          chunkData: response?.getChunkData(),
        });
        // setWhatsappId(response?.getId());
      })
      .catch((error) => {
        console.error("Error fetching WhatsApp data:", error);
        if (error.response?.status === 401) {
          setSnackbar({
            open: true,
            message: "Please log in to access WhatsApp features",
            severity: "error",
          });
        }
      });
  }

  function fetchCatalog() {
    ServicesService.getCatalog().then((res) => setCatalogId(res));
  }
  function handleWhatsappChange(value, field) {
    setWhatsapp((prev) => ({
      ...prev,
      [field]: value,
    }));
  }
  async function handleSaveWhatsapp() {
    try {
      const model = new WhatsApp();
      model.setPhoneNumberId(whatsapp.phoneNumberId);
      model.setWabaId(whatsapp.wabaId);
      model.setAccessToken(whatsapp.accessToken);
      model.setStoreId(whatsapp.storeId);
      model.setPhoneNumber(whatsapp.businessNumber);
      model.setIsEmbeddedSignup(0);
      await ServicesService.createWhatsapp(model);
      setWhatsapp(model);
      // setWhatsappId(id);
      setSnackbar({
        open: true,
        message: "Chatbot created successfully!",
        severity: "success",
      });
      setIsProfileOpen(false);
    } catch (error) {
      const message = errorMessage(error);
      if (message) {
        setSnackbar({
          open: true,
          message: `${message}`,
          severity: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Something went wrong",
          severity: "error",
        });
      }
    }
  }
  async function handleSyncHistory(type) {
    try {
      await ServicesService.syncHistory(type);
      fetchData();
    } catch (error) {
      console.log('error', error);
      setSyncDialogOpen(false);
      const message = errorMessage(error);
      if (message) {
        setSnackbar({
          open: true,
          message: `${message}`,
          severity: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Something went wrong",
          severity: "error",
        });
      }
    }
  }

  useEffect(() => {
    if (!syncDialogOpen) return undefined;
    const needsPoll =
      whatsapp.isHistory === "in-progress" ||
      whatsapp.isContact === "in-progress";
    if (!needsPoll) return undefined;
    const id = setInterval(() => {
      fetchData();
    }, 4000);
    return () => clearInterval(id);
  }, [syncDialogOpen, whatsapp.isHistory, whatsapp.isContact]);

  useEffect(() => {
    if (profileDialogOpen) {
      fetchData();
      setIsProfileOpen(true);
    }
  }, [profileDialogOpen]);

  const handleCloseProfile = () => {
    setIsProfileOpen(false);
    if (onCloseProfileDialog) onCloseProfileDialog();
  };

  useEffect(() => {
    MyAccountService.fetch().then((model) => {
      setAccName(model);
    });
    ServicesService.getAppId().then((res) => {
      setAppId(res.appID);
      setConfigId(res.configID);
    });
    fetchData();
    fetchCatalog();
  }, []);
  function handleOpenFacebook() {
    setIsOpen(true);
  }
  function handleOpenCatalog() {
    fetchCatalog();
    setIsCatalogOpen(true);
  }

  async function completeEmbeddedSignup(code, payload) {
    try {
      if (!code || !payload?.phone_number_id || !payload?.waba_id) return;
      const model = new WhatsApp();
      model.setPhoneNumberId(payload.phone_number_id);
      model.setWabaId(payload.waba_id);
      model.setBusinessId(payload.business_id);
      model.setIsEmbeddedSignup(1);
      model.setOnboardingMode(payload.onboarding_mode || selectedOnboardingMode);
      model.setToken(code);
      const res = await ServicesService.createEmbeddedWhatsapp(model);
      console.log("short_token", code);
      console.log("user_token", res);
      pendingSignupRef.current = null;
      pendingAuthCodeRef.current = null;
      setIsOpen(false);
      setMoreAnchorEl(null);
      fetchData();
      setCopyDialogData({
        phone_number_id: payload.phone_number_id,
        waba_id: payload.waba_id,
      });
      setShowCopyDialog(true);
      setCopiedPhone(false);
      setCopiedWaba(false);
    } catch (error) {
      console.error("Error during token exchange:", error);
      setSnackbar({
        open: true,
        message: errorMessage(error) || "Could not complete WhatsApp onboarding",
        severity: "error",
      });
    }
  }

  useEffect(() => {
    function openFacebookDialog() {
      setIsOpen(true);
    }
    function openCatalogDialog() {
      fetchCatalog();
      setIsCatalogOpen(true);
    }
    window.addEventListener("open-connect-facebook", openFacebookDialog);
    window.addEventListener("open-connect-catalog", openCatalogDialog);
    return () => {
      window.removeEventListener("open-connect-facebook", openFacebookDialog);
      window.removeEventListener("open-connect-catalog", openCatalogDialog);
    };
  }, []);

  async function handleLogout() {
    const domain = API_CONFIG.BASE_URL;
    const url = `${domain}/signout`;
    setIsProfileOpen(false);
    await axios.post(
      url,
      {},
      {
        withCredentials: true,
      },
    );
    window.location.replace("/");
  }
  useEffect(() => {
    if (!appId) return;
    // Load Facebook SDK script if not already loaded
    if (!document.getElementById("facebook-jssdk")) {
      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v23.0",
      });
      setIsFbReady(true);
    };
    const allowedOrigins = [
      "https://www.facebook.com",
      "https://web.facebook.com",
      "https://business.facebook.com",
    ];

    async function handleMessage(event) {
      if (!allowedOrigins.includes(event.origin)) return;
      try {
        let data;
        console.log("embededEventData", event?.data);

        try {
          data =
            typeof event.data === "string"
              ? JSON.parse(event.data)
              : event.data;
        } catch {
          return;
        }
        if (data.type !== "WA_EMBEDDED_SIGNUP") return;

        if (
          data.event === "FINISH" ||
          data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"
        ) {
          const { phone_number_id, waba_id, business_id } = data.data;
          console.log("Phone:", phone_number_id, "WABA:", waba_id);
          const eventMode =
            data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"
              ? "business_app"
              : selectedOnboardingMode;
          const payload = {
            phone_number_id,
            waba_id,
            business_id,
            onboarding_mode: eventMode,
            embedded_event: data.event,
          };
          pendingSignupRef.current = payload;
          if (pendingAuthCodeRef.current) {
            await completeEmbeddedSignup(pendingAuthCodeRef.current, payload);
          }
        }

        if (data.event === "CANCEL") {
          console.warn("User cancelled at step:", data.data.current_step);
        }

        if (data.event === "ERROR") {
          console.error("Embedded signup error:", data.data.error_message);
        }
      } catch (err) {
        console.log("Raw message event:", event.data);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [appId, selectedOnboardingMode]);
  const launchWhatsAppSignup = () => {
    if (!isFbReady || !window.FB || !window.FB.login) {
      console.error("Facebook SDK is not ready yet.");
      return;
    }
    pendingSignupRef.current = null;
    pendingAuthCodeRef.current = null;
    function fbLoginCallback(response) {
      if (response.authResponse) {
        const { code } = response.authResponse;
        console.log("Token code:", code);
        if (pendingSignupRef.current) {
          completeEmbeddedSignup(code, pendingSignupRef.current);
        } else {
          pendingAuthCodeRef.current = code;
        }
      } else {
        console.log("FB login failed:", response);
      }
    }
    const extras = {
      setup: {},
      sessionInfoVersion: "3",
    };
    if (selectedOnboardingMode === "business_app") {
      extras.featureType = "whatsapp_business_app_onboarding";
    }
    window.FB.login(fbLoginCallback, {
      config_id: configId,
      response_type: "code",
      override_default_response_type: true,
      extras,
    });
  };
  const iswhatsapp =
    whatsapp.phoneNumberId != null || whatsapp.phoneNumberId !== "";

  return (
    <>
      {showToolbar && isMobile && (
        <AppBar
          position="fixed"
          sx={{
            zIndex: (t) => t.zIndex.drawer + 4,
            backgroundColor: "var(--theme-app-bar-bg)",
            color: "var(--theme-app-bar-text)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            width: "100%",
          }}
        >
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {onMenuClick && (
                <IconButton
                  onClick={onMenuClick}
                  edge="start"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
              )}
            </Box>
            <Box sx={{ width: 40 }} />
          </Toolbar>
        </AppBar>
      )}
      <Dialog
        open={isProfileOpen}
        onClose={handleCloseProfile}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          Whatsapp details
        </DialogTitle>
        <DialogContent sx={{ pt: 5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 1 }}>
            {(whatsapp.storeId === "stor_74ukjthhc8u64b9jcru3" ||
              whatsapp.storeId === "stor_6hgk8eb16gt66b9g6hjk") && (
              <>
                <TextField
                  label="Phonenumber Id"
                  placeholder={!iswhatsapp ? "Enter Phonenumber id" : null}
                  fullWidth
                  value={whatsapp.phoneNumberId}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "phoneNumberId")
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  label="Waba Id"
                  placeholder={!iswhatsapp ? "Enter Waba id" : null}
                  fullWidth
                  value={whatsapp.wabaId}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "wabaId")
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  label="Access Token"
                  placeholder={!iswhatsapp ? "Enter AccessToken" : null}
                  fullWidth
                  value={whatsapp.accessToken}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "accessToken")
                  }
                  // InputProps={{
                  //     readOnly: whatsapp.isEmbeddedSignup === 1,
                  // }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      //   ...(whatsapp.isEmbeddedSignup === 1 && {
                      //   pointerEvents: "none",
                      //   userSelect: "none",
                      //   color: "text.disabled"
                      // }),
                    },
                  }}
                />
              </>
            )}
            <TextField
              label="Whatapp Business Number"
              placeholder={!iswhatsapp ? "Enter Business Number" : null}
              fullWidth
              length={15}
              value={whatsapp.businessNumber}
              onChange={(e) =>
                handleWhatsappChange(e.target.value, "businessNumber")
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              label="Store Id"
              placeholder={!iswhatsapp ? "Enter store Id" : null}
              fullWidth
              value={whatsapp.storeId}
              onChange={(e) => handleWhatsappChange(e.target.value, "storeId")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={handleCloseProfile}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveWhatsapp}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderLoginDialog()}
      {renderCatalogDialog()}
      {renderCopyDialog()}
      {renderSyncDialog()}
    </>
  );
};

export default TopNavigation;
